import {Component, Input, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';

@Component({
    selector: 'app-niveau-vie',
    templateUrl: './niveau-vie.component.html',
    styleUrls: ['./niveau-vie.component.scss']
})
export class NiveauVieComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;

    constructor() {
    }

    ngOnInit() {
    }
}
